import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DownloadView from "../views/DownloadView.vue";
import WeView from "../views/WeView.vue";
import ProductItem from "../views/ProductItem.vue";
import OpenLoadView from "../views/OpenLoadView.vue";
import OpenLoadView1 from "../views/OpenLoadView1.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      tabName: "/",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun首页,船道,首页,www.powerfun,执行派,无锡执行派,上海执行派",
    },
  },
  {
    path: "/Download",
    name: "download",
    component: DownloadView,
    meta: {
      tabName: "/Download",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun,船道,www.powerfun,执行派,无锡执行派,上海执行派",
    },
  },
  {
    path: "/We",
    name: "we",
    component: WeView,
    meta: {
      tabName: "/We",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun,船道,www.powerfun,执行派,无锡执行派,上海执行派,powerfun简介,船道简介,powerfun详情,船道详情",
    },
  },
  {
    path: "/ProductItem",
    name: "productItem",
    component: ProductItem,
    meta: {
      tabName: "/",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun,船道,www.powerfun,执行派,无锡执行派,上海执行派,设备详情,powerfun详情",
    },
  },
  {
    path: "/DownloadView",
    name: "downloadView",
    component: OpenLoadView,
    meta: {
      tabName: "/Download",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun,船道,www.powerfun,执行派,无锡执行派,上海执行派",
    },
  },
  {
    path: "/DownloadView1",
    name: "downloadView1",
    component: OpenLoadView1,
    meta: {
      tabName: "/Download",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun,船道,www.powerfun,执行派,无锡执行派,上海执行派",
    },
  },

  {
    path: "/:pathMatch(.*)*", // 匹配所有未定义的路由
    component: HomeView, // 重定向到 404 页面
    meta: {
      tabName: "/",
      keywords:
        "powerfun,划船机,POWERFUN,智骑,数字赛艇测功仪,测功仪,powerfun首页,船道,首页,www.powerfun,执行派,无锡执行派,上海执行派",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to);
  // 设置 meta 标签
  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (!keywordsMeta) {
    keywordsMeta = document.createElement("meta");
    keywordsMeta.name = "keywords";
    document.head.appendChild(keywordsMeta);
  }
  keywordsMeta.content = to.meta.keywords;

  // let descriptionMeta = document.querySelector('meta[name="description"]');
  // if (!descriptionMeta) {
  //     descriptionMeta = document.createElement('meta');
  //     descriptionMeta.name = 'description';
  //     document.head.appendChild(descriptionMeta);
  // }
  // descriptionMeta.content = to.meta.description;

  next();
});

export default router;
